import {BASE_URL} from "../config/api";

export const fetchLogs = async () => {
  const res = await fetch(`${BASE_URL}/logs`);
  if (!res.ok) {
    throw new Error("Failed to fetch logs");
  }
  return res.json();
};
